export const places = [
  {
    label: 'Oslo',
    value: 'Oslo',
  },
  {
    label: 'Bergen',
    value: 'Bergen',
  },
  {
    label: 'Stavanger',
    value: 'Stavanger',
  },
  {
    label: 'Trondheim',
    value: 'Trondheim',
  },
  {
    label: 'Drammen',
    value: 'Drammen',
  },
  {
    label: 'Fredrikstad',
    value: 'Fredrikstad',
  },
  {
    label: 'Sarpsborg',
    value: 'Sarpsborg',
  },
  {
    label: 'Kristiansand',
    value: 'Kristiansand',
  },
  {
    label: 'Ålesund',
    value: 'Ålesund',
  },
  {
    label: 'Tønsberg',
    value: 'Tønsberg',
  },
  {
    label: 'Moss',
    value: 'Moss',
  },
  {
    label: 'Haugesund',
    value: 'Haugesund',
  },
  {
    label: 'Sandefjord',
    value: 'Sandefjord',
  },
  {
    label: 'Arendal',
    value: 'Arendal',
  },
  {
    label: 'Bodø',
    value: 'Bodø',
  },
  {
    label: 'Tromsø',
    value: 'Tromsø',
  },
  {
    label: 'Hamar',
    value: 'Hamar',
  },
  {
    label: 'Larvik',
    value: 'Larvik',
  },
  {
    label: 'Kongsberg',
    value: 'Kongsberg',
  },
  {
    label: 'Molde',
    value: 'Molde',
  },
  {
    label: 'Lillehammer',
    value: 'Lillehammer',
  },
  {
    label: 'Drøbak',
    value: 'Drøbak',
  },
  {
    label: 'Hønefoss',
    value: 'Hønefoss',
  },
  {
    label: 'Elverum',
    value: 'Elverum',
  },
  {
    label: 'Kongsvinger',
    value: 'Kongsvinger',
  },
];

export const jobTypes = [
  {
    label: 'Sommerjobb',
    value: 'summer_job',
  },
  {
    label: 'Deltid',
    value: 'part_time',
  },
  {
    label: 'Fulltid',
    value: 'full_time',
  },
  {
    label: 'Masteroppgave',
    value: 'master_thesis',
  },
  {
    label: 'Annet',
    value: 'other',
  },
];

export const yearValues = [
  {
    value: 1,
    label: '1. klasse',
  },
  {
    value: 2,
    label: '2. klasse',
  },
  {
    value: 3,
    label: '3. klasse',
  },
  {
    value: 4,
    label: '4. klasse',
  },
  {
    value: 5,
    label: '5. klasse',
  },
];
